export enum TerrainGenerationMessage {
  NoActiveTerrainError = 'Please load an active terrain with create & manage permissions to proceed.',
  NoPointCloudLayerError = 'Please add a point cloud layer from a site with create and manage permissions to the workspace.',

  NoActiveTerrain = 'The generated DTM will be used in place of the captured DEM for this iteration.',
  HasActiveTerrain = 'The generated DTM will replace the captured DEM for this iteration.',

  NoCapturedDTM = "The generated DTM will be used in place of the captured DEM for the selected layer's iteration.",
  HasCapturedDTM = "The generated DTM will replace the captured DEM for the selected layer's iteration.",

  NoCapturedDEM = "The generated DEM will be used in place of the captured DEM for the selected layer's iteration.",
  HasCapturedDEM = "The generated DEM will replace the captured DEM for the selected layer's iteration.",
}
